import PropTypes from 'prop-types';
import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

import Icon from '../../Atoms/Icon/Icon';

// VALID STATUS
// 'linked', 'unlinked', 'deactivated', 'no_internet', 'enabled', 'disabled',

const icons = {
  portUp: {
    deactivated: 'port-deactivated',
    linked: 'port-linked',
    unlinked: 'port-unlinked',
    no_internet: 'port-no-internet',
  },
  portDown: {
    deactivated: 'port-deactivated-down',
    linked: 'port-linked-down',
    unlinked: 'port-unlinked-down',
    no_internet: 'port-no-internet-down',
  },
  wifi: {
    enabled: 'port-wifi',
    disabled: 'port-wifi-unlinked',
    deactivated: 'port-wifi-unlinked',
  },
};

const iconsMap = {
  port1: 'portUp',
  port2: 'portUp',
  port3: 'portDown',
  port4: 'portDown',
  wifi: 'wifi',
};

const tooltipMap = {
  deactivated: 'Deactivated',
  linked: 'Available',
  unlinked: 'No Cable',
  enabled: 'Enabled',
  disabled: 'Disabled',
  no_internet: 'No Internet',
};

const getPortStatus = ({
  id,
  status,
  type,
  isPoweredDownPort,
  isNoInternetPort,
}) => {
  if (id === 'wifi' && isPoweredDownPort) {
    return 'disabled';
  }

  if (isPoweredDownPort) {
    return 'deactivated';
  }
  if (
    isNoInternetPort &&
    ['backup', 'alternate'].includes(type) &&
    status[id] !== 'unlinked'
  ) {
    return 'no_internet';
  }
  return status[id] || 'unlinked';
};

// isPoweredDownPort is considered as deactivated
const PortIcon = ({
  id = '',
  status,
  type,
  isPoweredDownPort,
  isNoInternetPort,
}) => {
  const portStatus = getPortStatus({
    id,
    status,
    type,
    isPoweredDownPort,
    isNoInternetPort,
  });
  return (
    <OverlayTrigger
      placement="bottom"
      delay={{ show: 250, hide: 400 }}
      overlay={
        <Tooltip id="tooltip-bottom">
          <span>{tooltipMap[portStatus]}</span>
        </Tooltip>
      }
    >
      <div style={{ width: '40px', height: '40px' }}>
        <Icon className="h1 my-0" name={icons[iconsMap[id]]?.[portStatus]} />
      </div>
    </OverlayTrigger>
  );
};

PortIcon.propTypes = {
  id: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  isPoweredDownPort: PropTypes.bool.isRequired,
  isNoInternetPort: PropTypes.bool.isRequired,
  status: PropTypes.shape({}).isRequired,
};

export default PortIcon;
